import { render, staticRenderFns } from "./p29.vue?vue&type=template&id=01f0c1fe&scoped=true&"
import script from "./p29.vue?vue&type=script&lang=js&"
export * from "./p29.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f0c1fe",
  null
  
)

export default component.exports